
import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";
import { UserProfileRole } from '@app/shared/classes/user-profile-role';
export const DefaultUserProfile = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as UserProfileEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<UserProfileEditCriteria>,
}
export interface UserProfileEditCriteria {
  userProfile_Id: number;
  apexId: string;
  userName: string;
  country: string;
  subRegion_Id: number,
  terminal_Ids: number[],
  businessTypes: string,
  role_id: number;
  role: UserProfileRole;
}

